import smartRevision from './smartRevision'
import history from './history'

export { history, smartRevision }
